// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iR","message":"iS","close":"iT","closeMessage":"iU","closeIcon":"iV"};